import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';
import { FileType } from '../constants';

function mttUploadFileQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function mttUploadFileInput(base64Data: string, fileName: string, fileType: FileType, companyName: string): IDataServiceRequest {
    const query = mttUploadFileQuery();

    return query.createDataServiceRequestForOperation(
        'MTTUploadFile',
        true,
        DataServiceEntities.FileResponseClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IFileResponse' },
        {
            fileData: {
                Base64Data: base64Data,
                Name: fileName,
                Type: fileType?.toString()
            },
            companyName
        }
    );
}

export function mttUploadFileAsync(
    context: IContext,
    base64Data: string,
    fileName: string,
    fileType: FileType,
    companyName: string
): AsyncResult<DataServiceEntities.IFileResponse> {
    const request = mttUploadFileInput(base64Data, fileName, fileType, companyName);
    return callActionOrExecute<DataServiceEntities.IFileResponse>(request, context.callerContext);
}

function mttDeleteFileQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function mttDeleteFileInput(fileUrl: string): IDataServiceRequest {
    const query = mttDeleteFileQuery();

    return query.createDataServiceRequestForOperation(
        'MTTDeleteFile',
        true,
        DataServiceEntities.OperationResultClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.OperationResultClass' },
        { fileUrl }
    );
}

export function mttDeleteFileAsync(context: IContext, fileUrl: string): AsyncResult<DataServiceEntities.OperationResultClass> {
    const request = mttDeleteFileInput(fileUrl);
    return callActionOrExecute<DataServiceEntities.OperationResultClass>(request, context.callerContext);
}

function mttGetBusinessSegmentsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function mttGetBusinessSegmentsInput(): IDataServiceRequest {
    const query = mttGetBusinessSegmentsQuery();

    return query.createDataServiceRequestForOperation('MTTGetBusinessSegments', false, DataServiceEntities.BusinessSegment, 'true', {
        bypassCache: 'get',
        returnEntity: 'DataServiceEntities.BusinessSegment'
    });
}

export function mttGetBusinessSegmentsAsync(context: IContext): AsyncResult<DataServiceEntities.BusinessSegment[]> {
    const request = mttGetBusinessSegmentsInput();

    return callActionOrExecute<DataServiceEntities.BusinessSegment[]>(request, context.callerContext);
}

function mttGetChannelAffiliationZonesByCountyQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function mttGetChannelAffiliationZonesByCountyInput(context: IContext, countyId: string, channelId: number): IDataServiceRequest {
    const query = mttGetChannelAffiliationZonesByCountyQuery().resultSettings(context.queryResultSettings!);

    return query.createDataServiceRequestForOperation(
        'MTTGetChannelAffiliationZonesByCounty',
        true,
        DataServiceEntities.ChannelAffiliationZoneClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ChannelAffiliationZoneClass' },
        { countyId: countyId, zoneChannelId: channelId }
    );
}

export function mttGetChannelAffiliationZonesByCountyAsync(
    context: IContext,
    countyId: string,
    channelId: number
): AsyncResult<DataServiceEntities.ChannelAffiliationZoneClass[]> {
    const request = mttGetChannelAffiliationZonesByCountyInput(context, countyId, channelId);
    return callActionOrExecute<DataServiceEntities.ChannelAffiliationZoneClass[]>(request, context.callerContext);
}

function mttGetZoneWarehousesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function mttGetZoneWarehousesInput(context: IContext, countyId: string): IDataServiceRequest {
    const query = mttGetZoneWarehousesQuery();

    return query.createDataServiceRequestForOperation(
        'MTTGetZoneWarehouses',
        true,
        EntityClasses.WarehouseClass,
        'true',
        { bypassCache: 'get', returnEntity: 'EntityClasses.WarehouseClass' },
        { zone: countyId }
    );
}

export function mttGetZoneWarehousesAsync(context: IContext, countyId: string): AsyncResult<EntityClasses.WarehouseClass[]> {
    const request = mttGetZoneWarehousesInput(context, countyId);
    return callActionOrExecute<EntityClasses.WarehouseClass[]>(request, context.callerContext);
}

function mttCheckB2CEmailQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function mttCheckB2CEmailRequest(email: string): IDataServiceRequest {
    const query = mttCheckB2CEmailQuery();

    return query.createDataServiceRequestForOperation(
        'MTTCheckB2CEmail',
        false,
        DataServiceEntities.B2CEmailInfo,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.B2CEmailInfo' },
        { email }
    );
}

export function mttCheckB2CEmailAsync(context: IContext, email: string): AsyncResult<DataServiceEntities.B2CEmailInfo> {
    const request = mttCheckB2CEmailRequest(email.trim());

    return callActionOrExecute<DataServiceEntities.B2CEmailInfo>(request, context.callerContext);
}

function mttGetGuaranteeTypesInput(): IDataServiceRequest {
    const query = new DataServiceQuery();

    return query.createDataServiceRequestForOperation(
        'MTTGetGuaranteeInsuranceTypes',
        true,
        DataServiceEntities.GuaranteeInsuranceType,
        'true',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.GuaranteeInsuranceType'
        }
    );
}

export function mttGetGuaranteeTypesAsync(context: IContext): AsyncResult<DataServiceEntities.GuaranteeInsuranceType[]> {
    const request = mttGetGuaranteeTypesInput();

    return callActionOrExecute<DataServiceEntities.GuaranteeInsuranceType[]>(request, context.callerContext);
}

function mttGetPaymentTermsInput(): IDataServiceRequest {
    const query = new DataServiceQuery();

    return query.createDataServiceRequestForOperation(
        'MTTGetCreditAdjustmentPaymentTerms',
        true,
        DataServiceEntities.CreditAdjustmentPaymentTerms,
        'true',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.CreditAdjustmentPaymentTerms'
        }
    );
}

export function mttGetPaymentTermsAsync(context: IContext): AsyncResult<DataServiceEntities.CreditAdjustmentPaymentTerms[]> {
    const request = mttGetPaymentTermsInput();

    return callActionOrExecute<DataServiceEntities.CreditAdjustmentPaymentTerms[]>(request, context.callerContext);
}

function mttGetCreditApplyFileTemplateInput(): IDataServiceRequest {
    const query = new DataServiceQuery();

    return query.createDataServiceRequestForOperation(
        'MTTGetCreditApplyFileTemplate',
        true,
        DataServiceEntities.FileResponseClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IFileResponse'
        }
    );
}

export function mttGetCreditApplyFileTemplateAsync(context: IContext): AsyncResult<DataServiceEntities.IFileResponse> {
    const request = mttGetCreditApplyFileTemplateInput();

    return callActionOrExecute<DataServiceEntities.IFileResponse>(request, context.callerContext);
}

function mttCreateCreditLimitAdjustmentInput(
    paymentTerm: string,
    guaranteeType: string,
    custAccount: string,
    creditMaxNew: number,
    creditApplicationFormUrl: string,
    guaranteeFormUrl: string
): IDataServiceRequest {
    const query = new DataServiceQuery();

    return query.createDataServiceRequestForOperation(
        'MTTCreateCreditLimitAdjustment',
        true,
        DataServiceEntities.OperationResultClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.OperationResultClass' },
        {
            creditLimitAdjustment: {
                PaymentTerm: paymentTerm,
                GuaranteeType: guaranteeType,
                CustAccount: custAccount,
                CreditMaxNew: creditMaxNew,
                CreditApplicationFormUrl: creditApplicationFormUrl,
                GuaranteeFormUrl: guaranteeFormUrl
            }
        }
    );
}

export function mttCreateCreditLimitAdjustmentAsync(
    context: IContext,
    paymentTerm: string,
    guaranteeType: string,
    custAccount: string,
    creditMaxNew: number,
    creditApplicationFormUrl: string,
    guaranteeFormUrl: string
): AsyncResult<DataServiceEntities.OperationResultClass> {
    const request = mttCreateCreditLimitAdjustmentInput(
        paymentTerm,
        guaranteeType,
        custAccount,
        creditMaxNew,
        creditApplicationFormUrl,
        guaranteeFormUrl
    );
    return callActionOrExecute<DataServiceEntities.OperationResultClass>(request, context.callerContext);
}

function mttGetOrganizationAttributesInput(): IDataServiceRequest {
    const query = new DataServiceQuery();

    return query.createDataServiceRequestForOperation('MTTGetOrganizationAttributes', false, EntityClasses.CustomerAttributeClass, 'true', {
        bypassCache: 'get',
        returnEntity: 'EntityClasses.CustomerAttributeClass'
    });
}

export function mttGetOrganizationAttributesAsync(context: IContext): AsyncResult<EntityClasses.CustomerAttributeClass[]> {
    const request = mttGetOrganizationAttributesInput();
    return callActionOrExecute<EntityClasses.CustomerAttributeClass[]>(request, context.callerContext);
}
